/**
 * @desc 关闭音视频会议飘窗
 */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {
  /** uuid */
  uuid: string;
}

export const method = 'GET';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey('/api/bs-vmeeting/v3/member/window/close', params, 'GET'),
    newValue,
    shouldRevalidate,
  );
}

export function useRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/v3/member/window/close',
    params,
    swrOptions,
  );
}

export function request(params: Params, options?: any) {
  return PontCore.fetch(
    PontCore.getUrl('/api/bs-vmeeting/v3/member/window/close', params, 'GET'),
    {
      method: 'GET',

      ...options,
    },
  );
}
